import * as React from 'react';
import Grid from '@mui/material/Grid';
import { useField } from 'formik';
import Checkbox from '../Checkbox';

export default function CheckboxGroupComponent({ list = [], name }) {
  const [field] = useField({ name });
  return (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      {list.map((x, index) => (
        <Grid item xs={12} sm={3} key={index}>
          <Checkbox
            id={x.value}
            {...field}
            value={x.value}
            checked={field && field.value && field.value.includes(x.value)}
            label={x.label}
          />
        </Grid>
      ))}
    </Grid>
  );
}
